import { Component } from '@angular/core';

import { Router } from '@angular/router';
import { Store, Select } from '@ngxs/store';
import {
  SweetAlertService,
  WhitelabelState,
  Whitelabel,
  environment,
  LocationState,
  DeliveryState
} from '@moduurnv2/libs-orderingapp/src/core';
import { LocationInfoBaseComponent } from '@moduurnv2/libs-orderingapp';
import { ThemeOptions } from '@moduurnv2/features/ui/directives';
import { Observable } from 'rxjs';
import { FuturePickerComponent } from '../../../shared';
import { ModalService } from '../../../shared/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'moduurnv2-location-info',
  templateUrl: './location-info.component.html',
  styleUrls: ['./location-info.component.scss'],
})
export class LocationInfoComponent extends LocationInfoBaseComponent {
  @Select(WhitelabelState.getWhitelabel) whitelabel$: Observable<Whitelabel>;
  themeOptions: ThemeOptions = {
    appPrimaryColor: true,
  };
  logoIcon: string = environment.image_basepath + environment.images.logo_big;

  constructor(
    public router: Router,
    public store: Store,
    public sweetAlert: SweetAlertService,
    modal: ModalService,    
    public translate: TranslateService,
  ) {
    super(router, store, sweetAlert,modal, translate);
  }
  futureLocation;
  getLogo(whitelabel) {
    if (whitelabel) {
      const { restaurantLogo } = whitelabel;
      return `${environment.imagebaseurl}${restaurantLogo}`;
    }
    return this.logoIcon;
  }
  futureOrderFromOrganization(location) {
    this.futureLocation = location;
    this.modal.showFuture(FuturePickerComponent, {
      data: {
        orderSettings: location.orderSettings,
        locationName: location.name,
        location: location,
      },
      whenClosed: (data) => {
        if (data) this.orderFromOrganization(location, data);
      },
    });
  }

  orderFromLocation(location){
    if(location?.orderSettings?.asapOrder && location?.orderSettings?.futureOrder){
      const allowASAP = location.orderSettings.asapOrder.isAllow;
      const allowFuture = location.orderSettings.futureOrder.isAllow;
      const isLocationOpen = location.allow && location.isOpen;
      const locationDeliveryTypes = location.deliveryTypes;
      let isSelectedClassroomDelivery = false;
      const selectedLocation = this.store.selectSnapshot(LocationState.getSelectedLocation);
      const selectedDelivery = this.store.selectSnapshot(DeliveryState.getSelectedDelivery);
      if((locationDeliveryTypes?.length == 1 && locationDeliveryTypes[0].textCode == 'DELIVERYTYPE10') || (selectedLocation?._id == location._id && selectedDelivery?.textCode == 'DELIVERYTYPE10')){
        isSelectedClassroomDelivery = true;
      } else if(locationDeliveryTypes?.length > 1 && locationDeliveryTypes[0].textCode == 'DELIVERYTYPE10'){
        isSelectedClassroomDelivery = true;
      }

      if(isSelectedClassroomDelivery){
        let data ={
          isSelectedClassroomDelivery : isSelectedClassroomDelivery
        }
        this.orderFromOrganization(location,data);
      } else if(allowASAP && allowFuture && !isLocationOpen){
        this.futureOrderFromOrganization(location);
      } else if(allowASAP && allowFuture && isLocationOpen){
        this.orderFromOrganization(location);
      } else if(!allowASAP && allowFuture && isLocationOpen){
        this.futureOrderFromOrganization(location);
      } else if(allowASAP && !allowFuture && isLocationOpen){
        this.orderFromOrganization(location);
      } else if(!allowASAP && allowFuture && !isLocationOpen){
        this.futureOrderFromOrganization(location);
      } else if(!allowASAP && allowFuture && !isLocationOpen){
        this.futureOrderFromOrganization(location);
      } else if(allowASAP && !allowFuture && !isLocationOpen){
        this.orderFromOrganization(location);
      } else{
        this.orderFromOrganization(location);
      }

    }
  }

}
